const Fetcher = require('od-modules/utils/fetcher');
const trackingUtils = require('od-modules/utils/tracking.utils');

module.exports = Odigeo.View.extend({
    selectors: {
        containerSubscriptionLink: '.od_newsletter_subscription_link_container',
        unsubscribeLink: '.price_manager_unsubscribe_link',
        subscribeLink: '.price_manager_subscribe_link',
        newsletterModal: '.price_manager_subscribe_modal',
    },

    tmpls: {
        mainTemplate: '#call-us-header-template',
    },

    events: {
        'tap @subscribeLink': 'onClickNewsletterSubscription',
        'tap @unsubscribeLink': 'onClickNewsletterUnsubscription',
    },

    init() {
        if (!Odigeo.AB.isConsentRequest) {
            this.toggleNewsletterSubscriptionStatus();
        }

        if (Odigeo.AB.isNewNewsletterLogic) {
            this.initializeNewNewsletterText();
        } else {
            this.initializeOldNewsletterText();
        }

        this.email = '';
        this.unsubscribeFromUrl = '';
        this.isSubscription = 'S';
        this.campaign = 'gdpr';
    },

    initializeNewNewsletterText() {
        $('.subscribe_legal_text').addClass('odf-hidden');
        $('.new_subscribe_legal_text').addClass('odf-hidden');
    },

    initializeOldNewsletterText() {
        $('.new_unsubscribe_legal_text').addClass('odf-hidden');
        $('.new_subscribe_legal_text').addClass('odf-hidden');
    },

    onClickNewsletterSubscription(showModal) {
        this.manageNewsletterSubscription('S', showModal);
        this.setSubscriptionUser('S');
    },

    onClickNewsletterUnsubscription(showModal) {
        this.manageNewsletterSubscription('U', showModal);
        this.setSubscriptionUser('U');
    },

    setNewsletterEmail(email) {
        this.email = email;
    },

    setUnsubscribeFromUrl(url) {
        this.unsubscribeFromUrl = url;
    },

    setSubscriptionUser(isSubscription) {
        this.isSubscription = isSubscription;
    },

    setNewsletterCampaign(campaign) {
        this.campaign = campaign;
    },

    suscribeToNewsletter() {
        if (this.isSubscription === 'U') {
            return;
        }
        const NEWSLETTER_SUBSCRIPTION_ENDPOINT = '/travel/service/subscriptions/newsletter/subscribe';
        const email = this.email;
        const campaign = this.campaign;

        Fetcher.post(NEWSLETTER_SUBSCRIPTION_ENDPOINT, {email, campaign}).json();
    },

    unsubscribeToNewsletter() {
        if (this.isSubscription === 'S') {
            return;
        }
        const NEWSLETTER_UNSUBSCRIPTION_ENDPOINT = '/travel/service/subscriptions/newsletter/unsubscribe';
        const email = this.email;
        const url = this.unsubscribeFromUrl;

        Fetcher.post(NEWSLETTER_UNSUBSCRIPTION_ENDPOINT, {email, url}).json();
    },

    manageNewsletterSubscription(subscribeToken, showModal = true) {
        var trackingLabel = subscribeToken === 'U' ? 'unsubscribe' : 'subscribe';
        const action = Odigeo.SessionScope.flow === 'mobile' ? 'passengersinfo' : 'details';

        if (showModal) {
            this.$cachedSelectors.newsletterModal.removeClass('odf-hidden');
        }

        trackingUtils.trackEvent(action, 'link_newsletter_' + trackingLabel);
        Odigeo.Session.set('changeNewsletterSubscriptionToken', subscribeToken);

        if (showModal) {
            setTimeout(Odigeo._.bind(this.toggleNewsletterSubscriptionStatus, this), 5000);
        }
    },
    showNewSubscriptionText() {
        $('.new_unsubscribe_legal_text').addClass('odf-hidden');
        $('.new_subscribe_legal_text').removeClass('odf-hidden');
    },
    showNewUnsubscriptionText() {
        $('.new_subscribe_legal_text').addClass('odf-hidden');
        $('.new_unsubscribe_legal_text').removeClass('odf-hidden');
    },
    toggleNewsletterSubscriptionStatus() {
        var isUnsubscribe = Odigeo.Session.get('changeNewsletterSubscriptionToken') === 'U';
        this.$cachedSelectors.containerSubscriptionLink.toggleClass('od-suscribe', isUnsubscribe);
        this.$cachedSelectors.containerSubscriptionLink.toggleClass('od-unsuscribe', !isUnsubscribe);
        this.$cachedSelectors.newsletterModal.addClass('odf-hidden');

        if (Odigeo.AB.isNewNewsletterLogic) {
            if (isUnsubscribe) {
                this.showNewSubscriptionText();
            } else {
                this.showNewUnsubscriptionText();
            }
        }
    },
});
